import { useRouter } from 'expo-router'
import { useTranslation } from 'react-i18next'
import { Pressable, View } from 'react-native'
import { Text } from '@/components/ui/Text'
import { useThemeColors } from '@/contexts/ThemeContext'

const ADMIN_NAV_ROUTES = [
  { key: 'navHome', route: '/hq' },
  { key: 'navApplications', route: '/hq/applications' },
  { key: 'navCohorts', route: '/hq/cohort' },
  { key: 'navWaitlist', route: '/hq/waitlist' },
  { key: 'navMeetups', route: '/hq/meetups' },
]

export default function AdminNav({ activeRoute }: { activeRoute: string }) {
  const router = useRouter()
  const colors = useThemeColors()
  const { t } = useTranslation()

  return (
    <View
      style={{
        backgroundColor: colors.surface,
        borderBottomWidth: 1,
        borderBottomColor: colors.border,
        paddingVertical: 10,
        paddingHorizontal: 16,
      }}
    >
      <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 8, justifyContent: 'center' }}>
        {ADMIN_NAV_ROUTES.map((item) => {
          const active = item.route === activeRoute
          return (
            <Pressable
              key={item.route}
              onPress={() => router.push(item.route as never)}
              style={{
                paddingHorizontal: 18,
                paddingVertical: 8,
                borderRadius: 20,
                backgroundColor: active ? colors.primary : 'transparent',
                borderWidth: 1.5,
                borderColor: active ? colors.primary : colors.border,
              }}
            >
              <Text
                style={{
                  fontSize: 13,
                  fontWeight: '600',
                  color: active ? '#fff' : colors.muted,
                }}
              >
                {t(`hq.${item.key}`)}
              </Text>
            </Pressable>
          )
        })}
      </View>
    </View>
  )
}
